export default [
    'TurnstileError',
    'NetworkError when attempting to fetch resource.',
    'Load failed.*',
    'Fetch is aborted.*',
    'ChunkLoadError',
    'Cannot assign to read only property.*',
    'Loading chunk .* failed'
];
